import { render, staticRenderFns } from "./VehicleSideBar.vue?vue&type=template&id=42aa46de&"
import script from "./VehicleSideBar.vue?vue&type=script&lang=js&"
export * from "./VehicleSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports